import { RevenueChart } from '../components/RevenueChart';
import { MRRCard } from '../components/MRRCard';
import { ChurnRateCard } from '../components/ChurnRateCard';
import { Card, CardHeader, CardContent } from '@/components/ui/Card';
import { PieChart } from '@/components/charts/PieChart';
import { useRevenueData } from '@/hooks/useAdminBilling';

const planColors: Record<string, string> = {
  Standard: '#3b82f6',
  Pro: '#22c55e',
  Enterprise: '#f59e0b',
  Starter: '#8b5cf6',
  Free: '#6b7280',
};

export function RevenueAnalyticsPage() {
  const { data: rawData } = useRevenueData('12m');
  const data = rawData as Record<string, unknown> | undefined;
  const rawRevenueByPlan = (Array.isArray(data?.revenueByPlan) ? data.revenueByPlan : []) as Array<{ name: string; value: number; color?: string }>;
  const revenueByPlan = rawRevenueByPlan.map((d) => ({
    name: d.name,
    value: d.value,
    color: d.color ?? planColors[d.name] ?? '#3b82f6',
  }));

  return (
    <div className="space-y-6">
      <div><h1 className="text-xl font-bold text-neutral-900 dark:text-neutral-100">Analytique revenus</h1><p className="text-sm text-neutral-500">Analyse détaillée des revenus</p></div>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <MRRCard />
        <ChurnRateCard />
      </div>
      <RevenueChart />
      <Card>
        <CardHeader title="Revenus par plan" />
        <CardContent>
          <PieChart data={revenueByPlan} height={280} />
        </CardContent>
      </Card>
    </div>
  );
}
